<template>
    <div class="page parralax" :class="{ off: off }">
        <PageHeader class="page-header" v-if="page.face == 'page' || client.homeHeader" :client="client" @back="back" :page="page" :showBack="page.face == 'page'" :showAvatar="page.face == 'home'" />
        <div class="page-container" :style="{ marginTop: marginTop+'px', backgroundColor, height: height+'px' }">
            <div v-if="page.src" class="page-background" style="position: fixed;">
                <img :src="page.src" width="100%" />
            </div>
            <div class="btn-box" :style="{ transform: 'scale('+scale+')', height: btnsHeight+'px' }" style="padding-bottom: 100px;background-color: rgba(200,0,0,0);">
                <component class="page-btn" v-for="(btn,k) in page.btns" :key="k" :is="btn.component" :btn="btn" :page="page" :style="btn.style" @clicked="onClick(btn)"></component>
            </div>
        </div>
        <div class="quill-box off-bottom dn">
            <div class="x"></div>
            <div class="ql-editor">

            </div>
        </div>
    </div>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue'
import CComp from '@/components/Cards/Comp.vue';
import CImage from '@/components/Cards/Image.vue'
import CLink from '@/components/Cards/Link.vue';
import CQr from '@/components/Cards/Qr.vue'
import CRotate from '@/components/Cards/Rotate.vue'
import CTerms from '@/components/Cards/Terms.vue'
import CText from '@/components/Cards/CText.vue'
import CVideo from '@/components/Cards/Video.vue';
import CBox from '@/components/Cards/Box.vue'
import CButton from '@/components/Cards/CButton.vue'
import CStamp from '@/components/Cards/CStamp.vue'
import CQrRefer from '@/components/Cards/QrRefer.vue'
import Card  from '@/components/Cards/Card.vue';
import WebSoc from '@/utils/WebSoc.js'
import CWallet from '@/components/Cards/CWallet.vue'
import CQuill from '@/components/Cards/CQuill.vue'
import CInput from '@/components/Cards/CInput.vue'

import { mapActions, mapMutations } from 'vuex'

export default {
    computed: {
        session_id () { return this.$store.state.session_id },
        customer_id () { return this.$store.state.customer_id },
        scale () { return this.$store.state.scale },
        quills ()  { return this.$store.state.quills }
    },
    components: {
        Card,
        CComp,
        CImage,
        CLink,
        CQr,
        CRotate,
        CTerms,
        CText,
        CVideo,
        CBox,
        CStamp,
        CButton,
        CQrRefer,
        CWallet,
        CQuill,
        CInput,
        PageHeader
    },
    props: ['client','page'],
    created () {
        var page = this.page;
        var client = this.client;
        this.marginTop = ( ( page.face == 'page' || client.homeHeader )  ? client.headerHeight : 0);
        this.backgroundColor = page.backgroundColor || client.backgroundColor || 'white'
    },
    data () {
        return {
            marginTop: 0,
            backgroundColor: '',
            height: 0,
            btnsHeight: 0,
            off: true,
            quill: false
        }
    },
    mounted () {
        this.off = false;
        this.height = ( parseInt(getComputedStyle(this.$el.parentElement).height) ) //- this.marginTop );
        var client = this.client;
        var page = this.page;
        page.btns.forEach(btn => {
            this.btnsHeight = Math.max(this.btnsHeight,btn.top + btn.height);
            this.getPending(btn)
        });
        this.btnsHeight += 500;
        //page.btns.forEach((btn,i) => console.log(i,{ action: btn.action, wallet_id: btn.wallet_id, page_id: btn.page_id, value: btn.value }));
        this.addFonts(page.fontFamilies);
        setTimeout(() => {
            WebSoc.SEND('viewPage',{ page_id: this.page._id, session_id: this.session_id, customer_id: this.customer_id, client_id: this.client._id },() => console.log('added pageView'));
        },1000);
        
    },
    methods: {
        onClick ( btn ) {
            console.log('btn.action',btn.action);
            switch ( btn.action ) {
                case 'page': return this.pushPage(btn.page_id);
                case 'slide': return this.getQuillSlide(btn.quill_id);
            }
            console.log('onClick btn',JSON.parse(JSON.stringify(btn)));
        },
        /*
        getQuillSlide ( btn ) {
            var quill_id = btn.quill_id;
            var quill = this.quills.find(q => q._id == quill_id);
            if ( quill ) return this.showQuill(quill);
            WebSoc.SEND({ t: 'getCQuill', data: { quill_id, client_id: this.client_id }},quill => {
                this.showQuill(quill);
                this.saveQuill(quill);
            });            
        },
        showQuill ( quill ) {
            var QLe = this.$el.querySelector('.ql-editor');
            var Qb = this.$el.querySelector('.quill-box');
            var QBx = Qb.querySelector('.x');
            QLe.innerHTML = quill.html;
            Qb.classList.remove('dn');
            setTimeout(() => {
                Qb.classList.add('show');
                QBx.onclick = () => {
                    Qb.classList.remove('show');
                    setTimeout(() => {
                        Qb.classList.add('dn');
                    },400)
                }
            },50)
        },
        */
        back () {
            this.off = true;
            this.popPage(this.page);
        },
        ...mapMutations([
            'popPage',
            'saveQuill'
        ]),
        ...mapActions([
            'getQuillSlide',
            'getPending',
            'pushPage',
            'addFonts'
        ])
    }
}

</script>

<style lang="scss">
.page.parralax-x {
    overflow-y: scroll;
    perspective: 8px;
    perspective-origin: 50%;
    .page-container {
        overflow-y: initial;
        position: fixed;
    }
    .page-background {
        position: absolute !important;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: translateZ(0px) !important;
    }
    .btn-box {
        overflow-y: initial;
        transform-origin: 50% 50%;
        transform: translateZ(3px) scale(0.65) translateY(-150px) !important;
    }
}    
.page {
    .page-container {
        position: absolute;
        width: 414px;
        float: left;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .quill-box {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: white;
        transition: transform 0.3s;
        transform: translateY(100%);
        &.show {
            transform: translateY(0px);
        }
        &.dn {
            display: none;
        }
    }
    .btn-box {
        position: absolute;
        top: 0px;
        left: 0px;
        overflow-y: scroll;
        width: 100%;

        transform-origin: 0px 0px;
        .page-btn {
            position: absolute;
        }
    }
}
</style>